import { CustomRoutes } from '@shared/consts/routes/custom-routes.const';
import { ProjectTeamListComponent } from '@project-modules/project-team/pages/project-team-list/project-team-list.component';

export const ProjectTeamRoutes: CustomRoutes = [
  {
    path: '',
    component: ProjectTeamListComponent
  },
];
